import i18n from '@/i18n'
import { UserModule } from '@/store/modules/user'
import API from '@/api'
import { Loader } from '@googlemaps/js-api-loader'
import json from './test.json'
import { SappModule } from '@/store/modules/app'

export default {
  name: 'AdmissionFenceMapDisplay',
  data() {
    return {
      loading: false,
      polygonArr: [],
      map: null,
      keywords: '',
      loader: null,
      activeIndex: -1,
      allPoints: [],
      geojson: [],
      timer: null,
      formData: {
        name: '',
        pointArr: []
      }
    }
  },
  watch: {
    '$store.state.sapp.language': {
      immediate: true,
      handler(newValue, oldValue) {
        this.loadGoogleMap()
      }
    }
  },
  created() {
    this.getAllLoadArea()
  },
  computed: {
    siteCode() {
      return UserModule.adminSiteCode || UserModule.siteCode
    },
    siteName() {
      return UserModule.siteName
    }
  },
  methods: {
    async getAllLoadArea() {
      this.loading = true
      try {
        window.actionStart('路区围栏列表')
      } catch (error) {
        console.log(error)
      }
      const res = await API.queryRoadAreaBySiteCode(this.siteCode)

      if (res.code === 0) {
        this.formData.pointArr = [...res.data]
        this.allPoints = this.formData.pointArr
        const res2 = await API.getSiteRoadFences({
          siteCode: this.siteCode
        })
        this.loading = false
        if (res2.statusCode === 200) {
          const arr = res2.data.siteRoadFences
          arr.forEach(e => this.geojson.push(JSON.parse(e)))
          const geoJsonData = {
            type: 'FeatureCollection',
            features: [...this.geojson]
          }
          this.loadGoogleMap(geoJsonData)
        }
      } else {
        this.formData.pointArr = []
      }
      try {
        window.actionEnd('路区围栏列表')
      } catch (error) {
        console.log(error)
      }
    },
    // TODO 地图移动到所选区域
    selectPoint(index, noMove) {
      this.activeIndex = index
      // this.map.data.setStyle((feature) => {
      //   // 根据 roadNo 设置填充颜色
      //   return {
      //     strokeColor: "#3C6EF0",
      //     strokeOpacity: 1,
      //     strokeWeight: 2,
      //     fillColor: "#3C6EF0",
      //     fillOpacity: 0.1,
      //   };
      // });
      // 查找所有 class 为 custom-marker active 的元素
      const elements = document.querySelectorAll('.custom-marker.active')

      // 遍历这些元素并删除 active class
      elements.forEach(function(element) {
        element.classList.remove('active')
      })
      // 使用选择器找到 data-index 为 1 的元素
      const element = document.querySelector(`[data-index="${index}"]`)
      // 为元素添加 active 类
      if (element) {
        element.classList.add('active')
      }
      setTimeout(() => {
        this.polygonActive(this.activeIndex, noMove)
      }, 0)
    },
    clearActiveMapPolygon() {
      this.polygonArr.forEach((node, i) => {
        node.polygon.setOptions({
          paths: node.data,
          strokeColor: '#3C6EF0',
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: '#3C6EF0',
          fillOpacity: 0.1,
          zIndex: 0
        })
        // 并且地图移到这个区域的中间
      })
    },
    querySearch() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.activeIndex = -1
        this.clearActiveMapPolygon()
        if (this.keywords !== '') {
          this.formData.pointArr = this.allPoints.filter(item => {
            return (item.areaName.toLowerCase().indexOf(this.keywords.toLowerCase()) > -1 || item.areaCode.toLowerCase().indexOf(this.keywords.toLowerCase()) > -1)
          })
        } else {
          this.formData.pointArr = [...this.allPoints]
        }
      }, 300)
    },
    async loadGoogleMap(geoJsonData) {
      if (googleMapLoaded) {
        const { Map } = await google.maps.importLibrary('maps')
        const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary(
          'marker',
        )
        this.map = new Map(document.getElementById('admissionFenceMapDisplayMapId'), {
          center: { lat: 24.7136, lng: 46.6753 },
          zoom: 13,
          disableDefaultUI: true,
          zoomControl: true,
          scaleControl: true,
          mapId: '1ea87b22125a4812' // Map ID is required for advanced markers.
        })
        this.map.data.addGeoJson(geoJsonData)
        this.map.data.setStyle({
          strokeColor: '#3C6EF0',
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: '#3C6EF0',
          fillOpacity: 0.1
        })
        const bounds = new google.maps.LatLngBounds()
        this.map.data.forEach((feature) => {
          if (feature.getGeometry().getType() === 'Polygon') {
            const center = this.getPolygonCenter(feature.getGeometry())
            const keys = Object.keys(feature)
            let key = 'Fg'
            keys.forEach(node => {
              if (feature[node].roadNo) {
                key = node
              }
            })
            this.addCcenterMarker(center, feature[key].roadNo, feature[key].fenceName)// feature.Fg.roadNo, feature.Fg.fenceName
            feature.getGeometry().getArray().forEach(function(path) {
              path.getArray().forEach(function(latlng) {
                bounds.extend(latlng)
              })
            })
          }
        })
        this.map.fitBounds(bounds)

        this.map.data.addListener('click', (event) => {
          this.map.data.revertStyle()
          this.map.data.overrideStyle(event.feature, {
            strokeColor: '#9045E6', // 使用十六进制颜色值
            fillColor: '#9045E6', // 使用十六进制颜色值
            zIndex: 1
          })
          const keys = Object.keys(event.feature)
          let key = 'Fg'
          keys.forEach(node => {
            if (event.feature[node].roadNo) {
              key = node
            }
          })
          this.activeIndex = event.feature[key].roadNo
          try {
            const areaRef = this.$refs['fence-' + this.activeIndex][0] // 获取引用的 DOM 元素
            if (areaRef) {
              areaRef.scrollIntoView({ behavior: 'smooth' }) // 滚动到该元素
            }
          } catch (error) {

          }

          this.selectPoint(this.activeIndex, 'noMove')
        })
      } else {
        const timmer = setInterval(async() => {
          clearInterval(timmer)
          const { Map } = await google.maps.importLibrary('maps')
          const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary(
            'marker',
          )
          this.map = new Map(document.getElementById('admissionFenceMapDisplayMapId'), {
            center: { lat: 24.7136, lng: 46.6753 },
            zoom: 13,
            disableDefaultUI: true,
            zoomControl: true,
            scaleControl: true,
            mapId: '1ea87b22125a4812' // Map ID is required for advanced markers.
          })
          this.map.data.addGeoJson(geoJsonData)
          this.map.data.setStyle({
            strokeColor: '#3C6EF0',
            strokeOpacity: 1,
            strokeWeight: 2,
            fillColor: '#3C6EF0',
            fillOpacity: 0.1
          })
          const bounds = new google.maps.LatLngBounds()
          this.map.data.forEach((feature) => {
            if (feature.getGeometry().getType() === 'Polygon') {
              const center = this.getPolygonCenter(feature.getGeometry())
              const keys = Object.keys(feature)
              let key = 'Fg'
              keys.forEach(node => {
                if (feature[node].roadNo) {
                  key = node
                }
              })
              this.addCcenterMarker(center, feature[key].roadNo, feature[key].fenceName)
              feature.getGeometry().getArray().forEach(function(path) {
                path.getArray().forEach(function(latlng) {
                  bounds.extend(latlng)
                })
              })
            }
          })
          this.map.fitBounds(bounds)

          this.map.data.addListener('click', (event) => {
            this.map.data.revertStyle()
            this.map.data.overrideStyle(event.feature, {
              strokeColor: '#9045E6', // 使用十六进制颜色值
              fillColor: '#9045E6', // 使用十六进制颜色值
              zIndex: 1
            })
            const keys = Object.keys(event.feature)
            let key = 'Fg'
            keys.forEach(node => {
              if (event.feature[node].roadNo) {
                key = node
              }
            })
            this.activeIndex = event.feature[key].roadNo
            try {
              const areaRef = this.$refs['fence-' + this.activeIndex][0] // 获取引用的 DOM 元素
              if (areaRef) {
                areaRef.scrollIntoView({ behavior: 'smooth' }) // 滚动到该元素
              }
            } catch (error) {

            }

            this.selectPoint(this.activeIndex, 'noMove')
          })
        }, 1000)
      }

      // return
      // if(this.loader) {

      // }
      // const loader = new Loader({
      //   apiKey: 'AIzaSyACHxdwES9fO40fLRlAzGXNQ0jZUSypaHg',
      //   version: 'weekly',
      //   language: SappModule.language || 'en', // 将 'ar' 改为 'en' 或 'zh-CN' 或 'zh-TW' 以更改语言,
      //   mapId: "1ea87b22125a4812", // Map ID is required for advanced markers.
      // })
      // this.loader = loader;
      // console.log(this.loader)
      // loader.load().then(async () => {
      //   const { Map } = await google.maps.importLibrary('maps')
      //   const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary(
      //     "marker",
      //   );
      //   this.map = new Map(document.getElementById('admissionFenceMapDisplayMapId'), {
      //     center: { lat: 24.7136, lng: 46.6753  },
      //     zoom: 13,
      //     disableDefaultUI: true,
      //     zoomControl: true,
      //     scaleControl: true,
      //     mapId: "1ea87b22125a4812", // Map ID is required for advanced markers.
      //   })
      //   this.map.data.addGeoJson(geoJsonData);
      //   this.map.data.setStyle({
      //     strokeColor: "#3C6EF0",
      //     strokeOpacity: 1,
      //     strokeWeight: 2,
      //     fillColor: "#3C6EF0",
      //     fillOpacity: 0.1,
      //   });
      //   const bounds = new google.maps.LatLngBounds();
      //   this.map.data.forEach((feature) => {
      //     if (feature.getGeometry().getType() === 'Polygon') {
      //       const center = this.getPolygonCenter(feature.getGeometry());
      //       this.addCcenterMarker(center, feature.Fg.roadNo, feature.Fg.fenceName)
      //       feature.getGeometry().getArray().forEach(function(path) {
      //         path.getArray().forEach(function(latlng) {
      //           bounds.extend(latlng);
      //         });
      //       });
      //     }
      //   });
      //   this.map.fitBounds(bounds);

      //   this.map.data.addListener('click', (event) => {
      //     this.map.data.revertStyle();
      //     this.map.data.overrideStyle(event.feature, {
      //       strokeColor: '#9045E6', // 使用十六进制颜色值
      //       fillColor: '#9045E6',   // 使用十六进制颜色值
      //       zIndex: 1
      //     });
      //     this.activeIndex = event.feature.Fg.roadNo;
      //     this.selectPoint(this.activeIndex, 'noMove')
      //   })
      // }, ()=>{
      //   console.log('加载地图出错')
      // })
    },
    showAllPoint(latlngArr) {
      const bounds = new google.maps.LatLngBounds()
      latlngArr.forEach(latlng => {
        bounds.extend(latlng)
      })
      this.map.fitBounds(bounds)
    },
    async polygonActive(roadNo, noMove) {
      this.map.data.revertStyle()
      this.map.data.setStyle((feature) => {
        // 根据 roadNo 设置填充颜色
        if (feature.getProperty('roadNo') === roadNo) {
          try {
            this.showAllPoint(feature.getGeometry().Eg[0].Eg)
          } catch (error) {

          }
          if (!noMove) {
            const center = this.getPolygonCenter(feature.getGeometry())
            this.map.panTo(center)
          }
          this.map.data.overrideStyle(feature, {
            strokeColor: '#9045E6', // 使用十六进制颜色值
            fillColor: '#9045E6', // 使用十六进制颜色值
            zIndex: 1
          })
          return {
            strokeColor: '#9045E6',
            strokeOpacity: 1,
            strokeWeight: 2,
            fillColor: '#9045E6',
            fillOpacity: 0.1
          }
        } else {
          this.map.data.overrideStyle(feature, {
            strokeColor: '#3C6EF0', // 使用十六进制颜色值
            fillColor: '#3C6EF0', // 使用十六进制颜色值
            zIndex: 1
          })
          return {
            strokeColor: '#3C6EF0',
            strokeOpacity: 1,
            strokeWeight: 2,
            fillColor: '#3C6EF0',
            fillOpacity: 0.1
          }
        }
      })
    },
    async addCcenterMarker(center, roadNo, fenceName) {
      const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary(
        'marker',
      )
      const div = document.createElement('div')
      div.className = 'custom-marker'
      div.setAttribute('data-index', roadNo)
      div.innerHTML = roadNo
      const pinSvgMarkerView = new AdvancedMarkerElement({
        map: this.map,
        position: center,
        content: div,
        title: fenceName
      })
      pinSvgMarkerView.addListener('click', this.markerListener)
    },
    markerListener(e) {
      try {
        this.activeIndex = e.domEvent.target.getAttribute('data-index')
        this.selectPoint(this.activeIndex, 'noMove')
      } catch (error) {
        console.log(error)
      }
    },
    getPolygonCenter(geometry) {
      const bounds = new google.maps.LatLngBounds()
      try {
        const keys = Object.keys(geometry.getArray()[0])
        const key = keys[0]
        geometry.getArray()[0][key].forEach(function(latlng) {
          bounds.extend(latlng)
        })
      } catch (error) {
        console.log('发生错误', error, geometry.getArray())
        geometry.getArray()[0].Dg.forEach(function(latlng) {
          bounds.extend(latlng)
        })
      }

      return bounds.getCenter()
    }
  }
}
